import {
  Box,
  Tabs,
  Tab,
  Typography,
  Paper,
  Divider,
  Button,
  FormLabel,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useLocalization } from '@ui-framework/index';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import PreviousDateButton from '@product-framework/pages/ServiceJob/components/Map/widget/Filter/PreviousDateButton';
import NextDateButton from '@product-framework/pages/ServiceJob/components/Map/widget/Filter/NextDateButton';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FormattedMessage } from 'react-intl';
import JobDetails from './JobDetails';
import Filter from './Filter';

function JobAndSPWidget({
  jobInfo,
  jobLoading,
  spLoading,
  mapRef,
  serviceProviders,
  setActiveTab,
  setSearchText,
  setDispatchEventStatus,
  setServiceDate,
  setPagination,
  activeTab,
  searchText,
  dispatchEventStatus,
  serviceDate,
  pagination,
  dispatchStatusConfig,
  setDialog,
  onServiceProviderClick = () => undefined,
  isAssignedOrAcceptedSP = () => false,
  closeServiceProviderPopover,
  sortOptions,
  sortOption,
  setSortOption,
}) {
  const navigate = useNavigate();
  const { formatMessage } = useLocalization();

  const resetFormPostDateChange = date => {
    setPagination({
      ...pagination,
      page: 1,
    });
    setDispatchEventStatus(dispatchStatusConfig[0].value);
    setSearchText('');
    setServiceDate(date);
  };

  return (
    <Paper
      elevation={2}
      sx={{
        borderRadius: 2,
        p: 1,
        width: '350px',
        position: 'absolute',
        left: '15px',
        top: '80px',
      }}>
      <Button
        variant="text"
        onClick={() =>
          navigate(`/servicejobs/edit/${mapRef?.current?.job?.id}`)
        }
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start',
          width: '100%',
        }}>
        <Typography
          sx={{
            mb: 0,
            ml: 1,
            fontSize: '1.2em',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start',
            width: '100%',
          }}>
          {!jobLoading && `Job: ${mapRef?.current?.job?.serviceJobNumber}`}
        </Typography>
      </Button>
      <Divider sx={{ mt: 0.2, mb: 1 }} />
      <Grid2 xs={12}>
        <FormLabel
          htmlFor="serviceDate"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 1,
          }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
            <FormattedMessage id="DATE_IN_VIEW" defaultMessage="Date in View" />
          </Typography>
        </FormLabel>
        <Box sx={{ mt: 0.5, display: 'flex', alignItems: 'center', gap: 1 }}>
          <PreviousDateButton
            selectedDate={serviceDate}
            setSelectedDate={date => {
              resetFormPostDateChange(date);
            }}
          />
          <DatePicker
            id="serviceDate"
            value={serviceDate}
            onChange={newValue => {
              setServiceDate(newValue);
            }}
            slotProps={{ textField: { size: 'small' } }}
          />
          <NextDateButton
            selectedDate={serviceDate}
            setSelectedDate={date => {
              resetFormPostDateChange(date);
            }}
          />
        </Box>
      </Grid2>
      <Divider sx={{ mt: 2, mb: 1 }} />
      <Tabs
        TabIndicatorProps={{ style: { display: 'none' } }}
        sx={{
          minHeight: 32,
          borderBottom: 3,
          borderColor: 'primary.main',
          '& .MuiTab-root': {
            minHeight: 35,
            minWidth: 'auto',
            px: 1,
            py: 0.25,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          },
          '& .MuiTab-root.Mui-selected': {
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
          },
        }}
        value={activeTab}
        onChange={(_, v) => setActiveTab(v)}
        textColor="primary"
        indicatorColor="primary">
        <Tab
          label={formatMessage({
            id: 'JOB_DETAILS',
            defaultMessage: 'Job Details',
          })}
        />
        <Tab
          label={formatMessage({
            id: 'SERVICE_PROVIDERS',
            defaultMessage: 'Service Providers',
          })}
        />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {activeTab === 0 && (
          <JobDetails
            jobInfo={jobInfo}
            mapRef={mapRef}
            jobLoading={jobLoading}
            setDialog={setDialog}
          />
        )}
        {activeTab === 1 && (
          <Filter
            spLoading={spLoading}
            mapRef={mapRef}
            serviceProviders={serviceProviders}
            setSearchText={setSearchText}
            setDispatchEventStatus={setDispatchEventStatus}
            setServiceDate={setServiceDate}
            setPagination={setPagination}
            searchText={searchText}
            dispatchEventStatus={dispatchEventStatus}
            pagination={pagination}
            dispatchStatusConfig={dispatchStatusConfig}
            dispatchStatusDynamic
            onServiceProviderClick={onServiceProviderClick}
            isAssignedOrAcceptedSP={isAssignedOrAcceptedSP}
            jobInfo={jobInfo}
            closeServiceProviderPopover={closeServiceProviderPopover}
            sortOptions={sortOptions}
            sortOption={sortOption}
            setSortOption={setSortOption}
          />
        )}
      </Box>
    </Paper>
  );
}

export default JobAndSPWidget;
